import {
  Dialog,
  Transition,
  DialogPanel,
  TransitionChild,
} from "@headlessui/react";
import { Fragment } from "react";

type IPopupContainerProps = {
  open: boolean;
  children: React.ReactNode;
  onClose: () => void;
};
const PopupContainer: React.FC<IPopupContainerProps> = ({
  children,
  open,
  onClose,
}) => {
  const handleClose = () => {
    // Delay state update to ensure transitions complete
    setTimeout(() => {
      onClose();
    }, 300); // Matches the leave transition duration
  };

  return (
    <Transition show={open} as={Fragment}>
      <Dialog onClose={handleClose} className="relative z-50" unmount={true}>
        {/* 背景遮罩动画 */}
        <TransitionChild
          as={Fragment}
          enter="ease-[cubic-bezier(0.86,0,0.07,1)] duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          // leave="ease-[cubic-bezier(0.86,0,0.07,1)] duration-300"
          // leaveFrom="opacity-100"
          // leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/50" aria-hidden="true" />
        </TransitionChild>

        {/* 内容面板动画 */}
        <div className="fixed inset-0 flex items-center justify-center">
          <TransitionChild
            as={Fragment}
            enter="ease-[cubic-bezier(0.86,0,0.07,1)] duration-300"
            enterFrom="opacity-0 translate-y-[-50%]"
            enterTo="opacity-100 translate-y-0"
            leave="ease-in duration-300"
            leaveFrom="opacity-100 "
            leaveTo="opacity-0"
          >
            <DialogPanel className="bg-white rounded-lg w-full max-w-[517px] mx-4 md:mx-0 shadow-xl">
              {children}
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
};

export default PopupContainer;
